/**
 * Validation constants for forms and input fields
 */

/**
 * Recommendation notes validation constraints
 * Used in RecommendationDetailsModal for reject reason
 */
export const RECOMMENDATION_NOTES = {
  MIN_LENGTH: 10,
  MAX_LENGTH: 500,
} as const;

/**
 * Canned reasons for rejection — hardcoded helpers that moderators can append
 * to the rejection reason field with a single click.
 * Each entry has a short label (button text) and the full text that gets appended.
 */
export const REJECTION_CANNED_REASONS = [
  {
    label: "Brak istotnych zmian",
    text: "Brak istotnych zmian.",
  },
  {
    label: "Stary nabór",
    text: "Stary nabór - nie ma sensu go teraz dodawać.",
  },
  {
    label: "Dotyczy innego projektu",
    text: "Dotyczy innego projektu.",
  },
  {
    label: "Dodane inną rekomendacją",
    text: "Dodane inną rekomendacją.",
  },
  {
    label: "Nie dotyczy naboru",
    text: "Nie dotyczy naboru.",
  },
  {
    label: "Brak terminów nowego naboru",
    text: "Brak terminów nowego naboru.",
  },
] as const;

/**
 * Tooltip message shown on a canned reason button when the textarea is too full
 * to append the snippet without exceeding MAX_LENGTH.
 */
export const CANNED_REASON_TOO_FULL_MESSAGE =
  "Pole jest zbyt pełne, aby dopisać ten tekst";

/**
 * Prefix used in the active-state title and aria-label of canned reason buttons.
 */
export const CANNED_REASON_TITLE_PREFIX = "Dopisz:";
